import script from "./GuideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideModal.vue?vue&type=script&setup=true&lang=js"

import "./GuideModal.vue?vue&type=style&index=0&id=a3124afa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3124afa"]])

export default __exports__